export default __webpack_public_path__ + "static/char-v-20-8cb91dcdf0a4c72f2ae58f2c251aa8c8.png";